import axios from "axios";
import moment from "moment";
import React, { useEffect, useState, useContext } from "react";
import { Nav, Tab } from "react-bootstrap";
import { useParams } from "react-router-dom";
import swal from "sweetalert";
import { serverInfo } from "../../../App";
import Analytics from "./AnalyticsComponents/Analytics";
import "./FanbaseAdmin1.css";
import ApproveComponent from "./FanBaseComponents/ApproveComponent/ApproveComponent";
import DeclineComponent from "./FanBaseComponents/ApproveComponent/DeclineComponent";
import FanBaseGroup from "./FanBaseComponents/FanBaseGroup";
import FanBaseHome from "./FanBaseComponents/FanBaseHome";
import FanBaseMessenger from "./FanBaseComponents/FanBaseMessenger";
import FanBaseMedia from "./FanBaseComponents/MediaComponent/FanBaseMedia";
import FanBaseSetting from "./FanbaseSettingComponents/FanBaseSetting";
import JoiningRequest from "./Joining/JoiningRequest";

const FanbaseAdmin1 = () => {
  let { slug } = useParams();
  const [fanDetails, setFanDetails] = useState([]);
  const [color, setColor] = useState();
  const [checkApproveReal, setCheckApproveReal] = useState(false);
  const [checkDeclineReal, setCheckDeclineReal] = useState(false);
  const [chatUser, setChatUser] = useState();
  const { imageCdnUrl } = useContext(serverInfo);

  useEffect(() => {
    axios.get(`/api/admin/fan/group/show/${slug}`).then((res) => {
      if (res.status === 200) {
        setFanDetails(res.data.fanDetails);
        setChatUser(
          JSON.parse(res.data.fanDetails.my_user_join).length +
            JSON.parse(res.data.fanDetails.another_user_join).length
        );

        if (
          localStorage.getItem("auth_id") == res.data.fanDetails?.created_by
        ) {
          setColor(1);
        } else {
          setColor(2);
        }
      }
    });
  }, [slug]);

  function selectImage(file) {
    const formData = new FormData();
    formData.append("banner", file[0]);
    axios
      .post(`/api/admin/fan/group/image/update/${slug}`, formData)
      .then((res) => {
        if (res.status === 200) {
          setFanDetails(res.data.fanDetails);

          swal("Welcome", res.data.message, "success");
        }
      });
  }

  const checkAppReal = (data) => {
    setCheckApproveReal(data);
  };
  const checkDecReal = (data) => {
    setCheckDeclineReal(data);
  };

  return (
    <div className="container-fluid">
      <div
        className="  main-fan-container  p-0 "
        style={{
          height: "300px",
          backgroundImage: `url("${imageCdnUrl + fanDetails?.banner}")`,
          backgroundPosition: "center",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
        }}
      ></div>

      <div className="d-flex justify-content-around my-3">
        <div className="fileFan">
          <label for="input-file">
            <span>
              {" "}
              <i className="fas fa-camera mx-2"></i>Add Cover photo
            </span>
          </label>
          <input
            id="input-file"
            type="file"
            name="myImage"
            onChange={(e) => selectImage(e.target.files)}
          />
        </div>
      </div>

      <div className="container-fluid">
        <div className="">
          <div className="row">
            <div className="col-md-8">
              <div className="">
                <h2 className="text-light my-3">{fanDetails.group_name}</h2>

                <p className="text-muted">
                  Created at {moment(fanDetails.start_date).format("LL")} |
                  Continue till {moment(fanDetails.end_date).format("LL")}
                </p>

                <div className="my-3">
                  <Tab.Container
                    id="left-tabs-example"
                    defaultActiveKey="first"
                  >
                    <Nav
                      variant="pills"
                      className="d-flex justify-content-between flex-wrap"
                    >
                      <Nav.Item>
                        <Nav.Link className="NavColorFan my-1" eventKey="first">
                          <i className="fa fa-home mx-1" aria-hidden="true"></i>
                          Home
                        </Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link
                          className="NavColorFan my-1"
                          eventKey="second"
                        >
                          <i className="fas fa-image mx-1"></i>Media
                        </Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link className="NavColorFan my-1" eventKey="Third">
                          <i className="fa-solid fa-calendar-check mx-1"></i>{" "}
                          Approval
                        </Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link
                          className="NavColorFan my-1"
                          eventKey="seventh"
                        >
                          <i className="fa-solid fa-calendar-check mx-1"></i>{" "}
                          Decline
                        </Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link className="NavColorFan my-1" eventKey="Four">
                          <i className="fa-solid fa-chart-line mx-1"></i>
                          Analytics
                        </Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link className="NavColorFan my-1" eventKey="Fifth">
                          <i className="fa-solid fa-chart-line mx-1"></i>
                          Joining Request
                        </Nav.Link>
                      </Nav.Item>

                      <Nav.Item>
                        <Nav.Link className="NavColorFan my-1" eventKey="Six">
                          <i className="fa-solid fa-gear mx-1"></i> Settings
                        </Nav.Link>
                      </Nav.Item>
                    </Nav>
                    <Tab.Content className=" my-2">
                      <Tab.Pane eventKey="first">
                        <FanBaseHome checkApproveReal={checkApproveReal} />
                      </Tab.Pane>
                      <Tab.Pane eventKey="second">
                        <FanBaseMedia checkApproveReal={checkApproveReal} />
                      </Tab.Pane>
                      <Tab.Pane eventKey="Third">
                        <ApproveComponent
                          checkAppRealData={checkAppReal}
                          checkDecRealData={checkDecReal}
                        />
                      </Tab.Pane>
                      <Tab.Pane eventKey="seventh">
                        <DeclineComponent checkDeclineReal={checkDeclineReal} />
                      </Tab.Pane>
                      <Tab.Pane eventKey="Four">
                        <Analytics></Analytics>
                      </Tab.Pane>
                      <Tab.Pane eventKey="Fifth">
                        <JoiningRequest />
                      </Tab.Pane>
                      <Tab.Pane eventKey="Six">
                        <FanBaseSetting />
                      </Tab.Pane>
                    </Tab.Content>
                  </Tab.Container>
                </div>
              </div>
            </div>

            <div className="col-md-4">
              <div className="container my-2 ">
                <Tab.Container id="left-tabs-example" defaultActiveKey="group">
                  <Tab.Content className="my-2">
                    <Tab.Pane eventKey="group">
                      <FanBaseGroup />
                    </Tab.Pane>
                    <Tab.Pane eventKey="message">
                      <FanBaseMessenger
                        groupData={fanDetails && fanDetails}
                        color={color}
                        chatUser={chatUser}
                      />
                    </Tab.Pane>
                  </Tab.Content>
                  <Nav className="positionNavRel" variant="pills">
                    <Nav.Item>
                      <Nav.Link className="MessengerChat mx-2" eventKey="group">
                        <i className="fa-solid py-2 fa-user-group"></i>
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link className="MessengerChat" eventKey="message">
                        <i className="fa-brands py-2 fa-facebook-messenger"></i>
                      </Nav.Link>
                    </Nav.Item>
                  </Nav>
                </Tab.Container>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FanbaseAdmin1;
